import { shellStringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { AzureKeyVault } from './key-vault';
import { LinkedService } from './linkedservice';

@Metamodel.model({
    name: ModelConstants.cognitiveServiceLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.CognitiveService_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.CognitiveService_DisplayText)
    ]
})
export class CognitiveServiceLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.SubscriptionId,
        constraint: {
            required: true
        }
    })
    public subscriptionId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ResourceGroup,
        constraint: {
            required: true
        }
    })
    public resourceGroup?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CognitiveServiceName,
        constraint: {
            required: true
        }
    })
    public csName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CognitiveServiceKind,
        constraint: {
            required: true
        }
    })
    public csKind?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CognitiveServiceLocation,
        constraint: {
            required: true
        }
    })
    public csLocation?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CognitiveServiceEndpoint,
        constraint: {
            required: true
        }
    })
    public endPoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CognitiveServiceKey,
        constraint: {
            required: true
        }
    })
    public csKey?: AzureKeyVault;

    private _accountResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        let resourceName = '';
        if (this.endPoint) {
            resourceName = this.endPoint.substr(8).split('.')[0];
        }
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }
}
